import { ApiKeysPage } from '@/components/settings/api-key/api-keys-page';
import { SettingsSectionHeader } from '@/components/settings/section-header';
import { Layout } from '@/components/ui/design-system';
import { useTranslation } from '@/hooks/use-translation';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/api')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('desktop_ui');

  return (
    <Layout isScrollable contentClassName="max-w-[960px] px-20 !pt-0 pb-30">
      <section className="flex flex-col gap-4">
        <SettingsSectionHeader
          title={t('settings.sidebar.api')}
          description={t('settings.apiKeys.description')}
        />
        <ApiKeysPage />
      </section>
    </Layout>
  );
}
